module.exports = __webpack_public_path__ + "static/media/special-olympics.6ab27734.png";